// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../.yarn/__virtual__/css-loader-virtual-2ae40ad6f9/0/cache/css-loader-npm-3.5.3-0f886851e6-e5fa1707d7.zip/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-field-wrapper{display:flex;align-items:center}.modal-field-label{font-size:12;font-weight:400;margin-right:10;min-width:100;text-align:right}.manual-dataid-field-wrapper{margin:0 auto;width:90%;padding:0 0 5px 0}\n", ""]);
// Exports
module.exports = exports;
